import type { GriffelStyle } from '@fluentui/react-components'

/** Cap images/video/embeds to bubble width so they don't overflow. */
export const mediaStyles: GriffelStyle = {
  '& img, & video, & object, & embed, & svg': {
    maxWidth: '100%',
    height: 'auto',
  },
}
